/* =====================================================================
   You Fly LA — FOOTER "CURTAIN" on every page that is not the homepage or a yh- page (r12, 2026-09-29).

   Loaded by layout/theme.liquid only when yh_on is false. The homepage and the yh- pages keep assets/yh-home.js
   initReveal (section 15c) + the "Footer reveal" rules in assets/yh-home.css; this script also stands down by
   itself if it finds their footer (.yh-foot), or if #MainContent or .page-wrapper > footer is missing.

   Same behaviour as initReveal: the layout's <footer> (.page-wrapper > footer, holding sections/yfla-footer.liquid)
   is position:sticky at the bottom behind <main id="MainContent">, which becomes position:relative + z-index:1 and
   is painted with the page's own background colour, so it scrolls up and uncovers the footer like a curtain.
   The footer keeps its own height in the flow: the page is exactly as long as before (the same effect as a fixed
   footer plus main margin-bottom = footer height), nothing moves when the class is added (CLS 0), and the footer
   never covers Horizon's .page-wrapper scrollbar. Rules: assets/yfla-curtain.css.

   Mode = the "Footer Reveal (Curtain)" setting of sections/yfla-footer.liquid (data-reveal on .yfla-footer):
     "auto" (default)  the whole footer when it fits in 90% of the viewport; when it is taller, its first screen
                       is uncovered (its top pinned just under the stuck header, #header-group) and the rest
                       scrolls on normally;
     "fit"             only when the whole footer fits in 90% of the viewport;
     "off"             never.
   Never while the phone Call / Book bar (.yfla-mcta, snippets/yfla-mobile-cta.liquid) shows, never on screens under
   480px tall, and never on a page whose content ends inside the first screen (empty cart, 404: the footer is in
   view when the page opens, so a curtain would only hide its top). Re-measured on resize, footer / content resize
   and web-font load. No transition is added (reduced motion: nothing animates). Print: static.

   PEEK FIX (r16, 2026-09-30). The header wrapper (#header-group) is transparent around the floating bar, and the
   sticky footer's top sits at viewport height minus footer height. Whenever that is less than the header's bottom
   at the top of the page (about 136px; most laptops, with the 765-774px compact footer), the footer's top strip
   showed through the header's gaps at the top of the page. So while the end of <main> is more than one viewport
   below the viewport bottom, html.yfla-curtain--far clips the footer away completely (clip-path:
   inset(100% 0 0 0) in assets/yfla-curtain.css). clip-path keeps every
   footer link focusable and in the accessibility tree (no visibility / display change), and it paints nothing, so
   the page does not move (CLS 0). The switch is an IntersectionObserver on a 1px sentinel at the end of <main>
   whose root is extended one viewport downward, so the footer is back while <main> still covers it: there is
   nothing to flash. The resize / refresh path (apply) measures the same thing from geometry, and a passive scroll
   check runs only while the footer is clipped, so a jump (End key, an anchor, a script) that lands at the footer
   in one frame un-clips it in that same frame. A footer link that gets focus while clipped un-clips it at once and
   is then scrolled into the open as before.
   ===================================================================== */
(function () {
  'use strict';
  var d = document, root = d.documentElement;

  /* alpha of a computed colour: 0 for transparent, 1 for opaque */
  function alpha(c) {
    if (!c || c === 'transparent') return 0;
    var m = /\/\s*([\d.]+)(%?)\s*\)\s*$/.exec(c);
    if (m) return m[2] ? parseFloat(m[1]) / 100 : parseFloat(m[1]);
    m = /^rgba\(([^)]*)\)$/.exec(c);
    if (m) { var p = m[1].split(','); return p.length > 3 ? parseFloat(p[3]) : 1; }
    return 1;
  }

  function init() {
    if (d.querySelector('.yh-foot')) return;
    var main = d.getElementById('MainContent'), footer = d.querySelector('.page-wrapper > footer');
    if (!main || !footer) return;
    var cfg = footer.querySelector('[data-reveal]');
    var mode = (cfg && cfg.getAttribute('data-reveal')) || 'auto';
    if (mode === 'off') return;
    var hdr = d.getElementById('header-group'), on = false, far = false, io = null, ioRoot;
    /* <main>'s own background, read before the curtain rule applies (kept if a template already paints it) */
    var own = getComputedStyle(main).backgroundColor;

    function pageBg() {
      if (alpha(own) >= 1) return own;
      var b = getComputedStyle(d.body).backgroundColor;
      if (alpha(b) >= 1) return b;
      var h = getComputedStyle(root).backgroundColor;
      return alpha(h) >= 1 ? h : '#ffffff';
    }
    function phoneBar() { var b = d.querySelector('.yfla-mcta'); return !!b && getComputedStyle(b).display !== 'none'; }
    function scroller() {
      var pw = d.querySelector('.page-wrapper');
      return pw && /auto|scroll/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight + 2 ? pw : (d.scrollingElement || root);
    }
    /* height of the stuck header: #header-group is sticky with a negative top (the 36px strip scrolls away, the
       nav stays), so the part that stays on screen is its height plus that top. A sticky / fixed child of the
       group is used if the group itself is not the sticky element. */
    function headerH() {
      if (!hdr) return 0;
      var list = [hdr].concat([].slice.call(hdr.children));
      for (var i = 0; i < list.length; i++) {
        var cs = getComputedStyle(list[i]);
        if (cs.position === 'sticky' || cs.position === 'fixed') return Math.max(0, list[i].offsetHeight + (parseFloat(cs.top) || 0));
      }
      return 0;
    }
    /* where the content ends on the page (the footer's own top in the flow), in scroll coordinates */
    function contentEnd() {
      var sc = scroller(), top = (sc === d.scrollingElement || sc === root || sc === d.body) ? 0 : sc.getBoundingClientRect().top;
      return main.getBoundingClientRect().bottom - top + sc.scrollTop;
    }
    /* r16 peek fix: a 1px sentinel on the last line of <main>. It is absolutely placed (<main> is position:relative
       while the curtain is on), so it takes no space, and it is only in <main> while the curtain is on: base.css
       grows the last .shopify-section with :last-child, which matters only on a page shorter than the screen, and
       the curtain is never on there. */
    var mark = d.createElement('div');
    mark.setAttribute('aria-hidden', 'true');
    mark.setAttribute('data-yfla-curtain-mark', '');
    mark.style.cssText = 'position:absolute;left:0;bottom:0;width:1px;height:1px;margin:0;padding:0;border:0;pointer-events:none';
    /* the scroll box the page scrolls in: null (the viewport) or Horizon's .page-wrapper when that is the scroller */
    function box() { var sc = scroller(); return (sc === d.scrollingElement || sc === root || sc === d.body) ? null : sc; }
    function setFar(v) { far = !!v; root.classList.toggle('yfla-curtain--far', on && far); }
    /* true while the end of <main> is more than one viewport below the bottom of the scroll box */
    function measureFar() {
      var b = box(), bottom = b ? b.getBoundingClientRect().bottom : window.innerHeight, h = b ? b.clientHeight : window.innerHeight;
      return main.getBoundingClientRect().bottom > bottom + h;
    }
    function observe() {
      if (!('IntersectionObserver' in window)) return;
      var b = box();
      if (io && ioRoot === b) return;
      if (io) io.disconnect();
      ioRoot = b;
      io = new IntersectionObserver(function (list) {
        var e = list[list.length - 1], rb = e.rootBounds;
        /* far only when the sentinel is BELOW the extended box; above it (a footer taller than the screen) is near */
        setFar(!e.isIntersecting && (rb ? e.boundingClientRect.top > rb.bottom : measureFar()));
      }, { root: b, rootMargin: '0px 0px 100% 0px' });
      io.observe(mark);
    }
    function onScroll() { if (on && far && !measureFar()) setFar(false); }
    function apply() {
      var vh = window.innerHeight, fh = footer.offsetHeight, off = null;
      if (!phoneBar() && vh >= 480 && fh > 0 && contentEnd() >= vh) {
        if (fh <= vh * 0.9) off = 0;
        else if (mode === 'auto') off = Math.min(0, Math.round(vh - headerH() - fh));
      }
      on = off !== null;
      if (on) main.style.setProperty('--yfla-curtain-bg', pageBg());
      footer.style.setProperty('--yfla-fstick', on ? off + 'px' : '0px');
      root.classList.toggle('yfla-curtain', on);
      root.classList.toggle('yfla-curtain--screen', on && off < 0);
      if (on && mark.parentNode !== main) main.appendChild(mark);
      else if (!on && mark.parentNode) mark.parentNode.removeChild(mark);
      if (on) observe();
      setFar(on && measureFar());
    }
    /* keyboard: a footer link that gets focus while <main> still covers it is scrolled into the open */
    footer.addEventListener('focusin', function (e) {
      if (!on) return;
      setFar(false);
      requestAnimationFrame(function () {
        var r = e.target.getBoundingClientRect(), mb = main.getBoundingClientRect().bottom;
        if (r.top < mb + 8) { var sc = scroller(); sc.scrollTop += Math.ceil(mb - r.top + 24); }
      });
    });
    /* capture: also sees the scroll of .page-wrapper, which scrolls the page at 990px and up (base.css) */
    d.addEventListener('scroll', onScroll, { passive: true, capture: true });
    var t = null;
    function later() { clearTimeout(t); t = setTimeout(apply, 120); }
    window.addEventListener('resize', later);
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(later); ro.observe(footer); ro.observe(main); }
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(apply);
    apply();
    window.YFLA_curtain = { apply: apply, far: function () { return on && far; }, version: 'r16' };
  }

  function start() { try { init(); } catch (e) { if (window.console) console.warn('yfla-curtain', e); } }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
